// src/modules/app-views/invoices/pages/Init/components/tableColumns/totalAmountColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the total document amount column (totals.documentAmount).
function totalAmountColumn(buildColumnProps, options = {}) {
  return {
    title: translateX('total'),
    dataIndex: ['totals', 'documentAmount'],
    ...buildColumnProps('totals.documentAmount', { sort: true, search: false }),
    width: 120,
    align: 'right',
    render: (_, record) => {
      const total = record?.totals?.documentAmount;
      if (total === undefined || total === null) return '—';
      return <Text strong>{financialService.formatCurrency(total)}</Text>;
    },
  };
}

export default totalAmountColumn;
